jQuery(function($){
  
    const closePopup    = document.querySelector('.close-popup');
    const crossbtn      = document.querySelector('.cross-btn');
    const productfilter = document.querySelector('.product-filter'); 
    const toggleButton  = document.querySelector('.filter-toggle');
    const submitBtn     = document.querySelector('.submit-show-btn');   // NEW
 
    const CARD_SELECTOR   = '.juo-card';
    const GRID_SELECTOR   = '.juo-grid';
    const PILLS_SELECTOR  = '.pills-row .pill, .filter-options .filter-option';
    const INPUTS_SELECTOR = '.content-container input[type=checkbox], .content-container input[type=radio]';
    const CLEAR_SELECTOR  = '.bottom-button-container .cancel';
    const LOGIC_MODE      = 'AND';
    const CLEAR_TAGS      = ['all-meals','all'];
 
    const normalize = (s) =>
      (s || '')
        .toString()
        .toLowerCase()
        .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')  
        .replace(/[^a-z0-9]+/g, '-')                       
        .replace(/^-+|-+$/g, '');  
 
    function setButtonCount(count){
      if (!submitBtn) return;
      const noun = count === 1 ? 'meal' : 'meals';
      submitBtn.textContent = `Show ${count} ${noun}`;
    }

    function primeCards($cards){
      $cards.each(function(){
        const raw  = $(this).attr('data-tags') || '';
        const tags = raw.split(',').map(t => normalize(t.trim())).filter(Boolean);
        $(this).data('tags', new Set(tags));
      });
    }

    function getSelectedFilters(){
      const pills = $(PILLS_SELECTOR).filter('.active');
      const pillTags = $.makeArray(pills).map(el => {
        const $el = $(el);
        return normalize($el.data('tag') || $el.data('filter') || $el.text());
      });

      const inputs = $(INPUTS_SELECTOR).filter(':checked');
      const inputTags = $.makeArray(inputs).map(el => normalize($(el).val()));

      return [...new Set([...pillTags, ...inputTags].filter(Boolean))];
    }

    function matches(cardTagSet, filters){
      if (!filters.length) return true;
      if (LOGIC_MODE === 'OR') return filters.some(f => cardTagSet.has(f));
      return filters.every(f => cardTagSet.has(f));
    }
 
    function applyFilters(){
      const filters = getSelectedFilters();
      const $cards  = $(CARD_SELECTOR);
      let visible = 0;

      $cards.each(function(){
        let tagSet = $(this).data('tags');
        if (!(tagSet instanceof Set)) {
          const raw = $(this).attr('data-tags') || '';
          tagSet = new Set(raw.split(',').map(t => normalize(t.trim())).filter(Boolean));
          $(this).data('tags', tagSet);
        }
        const show = matches(tagSet, filters);
        $(this).toggleClass('is-hidden', !show);
        if (show) visible++;
      });

      setButtonCount(visible);  
      return visible;
    }

    document.addEventListener("setFilters", function(event) {
        applyFilters();  
    });
 
    const $grid  = $(GRID_SELECTOR);
    const $cards = $grid.length ? $grid.find(CARD_SELECTOR) : $(CARD_SELECTOR);
    primeCards($cards);
    applyFilters();  

     
    toggleButton && toggleButton.addEventListener('click', () => {
      productfilter && productfilter.classList.toggle('active');
      document.body.classList.add('overflow-hidden');
    });

    closePopup && closePopup.addEventListener('click', () => {
      productfilter && productfilter.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });

    crossbtn && crossbtn.addEventListener('click', () => {
      productfilter && productfilter.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });

    $(document).on('click', PILLS_SELECTOR, function(){
      const $btn = $(this);
      const tag = normalize($btn.data('tag') || $btn.data('filter') || $btn.text());

      if (CLEAR_TAGS.includes(tag)) {
        $(PILLS_SELECTOR).removeClass('active');
        $(INPUTS_SELECTOR).prop('checked', false);
      } else {
        $btn.toggleClass('active');
      }
      applyFilters();
    });

    $(document).on('change', INPUTS_SELECTOR, function(){
      applyFilters();
    });

    $(document).on('click', CLEAR_SELECTOR, function(e){
      e.preventDefault();
      $(PILLS_SELECTOR).removeClass('active');
      $(INPUTS_SELECTOR).prop('checked', false);
      applyFilters();
    });
 
    submitBtn && submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      productfilter && productfilter.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

       
      const grid = document.querySelector(GRID_SELECTOR);
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  $(document).ready(function () {
     
    const DELIVERY_CODES = {
      Wednesday: 'LMV',
      Saturday: 'LMVD',
    };

    const Loader = {
      el: null,
      ensure() {
        this.el = this.el || document.getElementById('page-loader');
      },
      show() {
        this.ensure();
        if (this.el) this.el.classList.remove('hidden');
      },
      hide() {
        this.ensure();
        if (this.el) this.el.classList.add('hidden');
      },
    };

    const $wrapper = $('#delivery-options');
    const $satLabel = $wrapper.find("label[for='day-selector-sat']");
    const $wedLabel = $wrapper.find("label[for='day-selector-wed']");
    const $satDateEl = $satLabel.find('.sat-date');
    const $wedDateEl = $wedLabel.find('.wed-date');
    const $inputs = $wrapper.find('.delivery-day-selector');
    const $code = $('#delivery-code');
    const $countdown = $('.diifrtm');
    const $hulllu = $countdown.find('.hulllu');
    const $bullu = $countdown.find('.bullu');

    const WED = 1;
    const SAT = 6;

    const nowLocal = () => new Date();

    const DAY_TO_LABEL = { Wednesday: 'delivery every monday', Saturday: 'delivery every monday' };
    const DAY_TO_CODE = { Wednesday: 'LMV', Saturday: 'LMVD' };

    function nextWeekday(targetDow, base = nowLocal()) {
      const d = new Date(base);
      d.setHours(0, 0, 0, 0);
      const currentDow = d.getDay();
      let delta = (targetDow - currentDow + 7) % 7;
      if (delta === 0) delta = 7;
      d.setDate(d.getDate() + delta);
      return d;
    }

    function previousWeekday(targetDow, fromDate) {
      const d = new Date(fromDate);
      d.setHours(0, 0, 0, 0);
      const dow = d.getDay();
      let delta = (dow - targetDow + 7) % 7;
      if (delta === 0) delta = 7;
      d.setDate(d.getDate() - delta);
      return d;
    }

    function atTime(dayDate, h, m, s) {
      const d = new Date(dayDate);
      d.setHours(h, m, s, 0);
      return d;
    }

    function formatDayLabel(d) {
      const locale = navigator.language || 'en-US';
      const day = String(d.getDate()).padStart(2, '0');
      const short = d.toLocaleString(locale, { month: 'short' });
      return `${day} ${short.charAt(0).toUpperCase() + short.slice(1)}`;
    }

    function cutoffForDelivery(deliveryDate) {
      const dow = deliveryDate.getDay();
      if (dow === WED) {
        const prevFri = previousWeekday(1, deliveryDate);
        return atTime(prevFri, 23, 59, 0);
      } else if (dow === SAT) {
        const prevTue = previousWeekday(2, deliveryDate);
        return atTime(prevTue, 23, 59, 0);
      }
    }

    function nextAvailable(targetDow) {
      let candidate = nextWeekday(targetDow);
      let cutoff = cutoffForDelivery(candidate);
      let attempts = 0;
      const maxHops = 8;
      while (nowLocal() > cutoff && attempts < maxHops) {
        candidate.setDate(candidate.getDate() + 7);
        cutoff = cutoffForDelivery(candidate);
        attempts++;
      }
      return { date: candidate, cutoff };
    }

    function computeModel() {
      const wed = nextAvailable(WED);
      const sat = nextAvailable(SAT);
      const list = [wed, sat].sort((a, b) => a.date - b.date);
      const first = wed;
      const second = sat;
      return { first, second, wed, sat };
    }

    function renderDates(model) {
      $satDateEl.text(formatDayLabel(model.sat.date));
      $wedDateEl.text(formatDayLabel(model.wed.date)); 
      const earliestIsWed = model.first.date.getDay() === WED;
      // $inputs.prop('checked', false);
      // $wrapper.find(`input[value='${earliestIsWed ? 'Wednesday' : 'Saturday'}']`).prop('checked', true);
      if(earliestIsWed){
        $('#delivery-options').css('flex-direction','row-reverse')
      }
    }

    function formatDuration(ms) {
      if (ms <= 0) return '00h 00m 00s';
      const totalSec = Math.floor(ms / 1000);
      const hours = Math.floor(totalSec / 3600);
      const mins = Math.floor((totalSec % 3600) / 60);
      const secs = totalSec % 60;
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
    }

    function selectedCutoff(model) {
      const val = $wrapper.find('.delivery-day-selector:checked').val();
      // if (val === 'Wednesday') return model.wed.cutoff;
      // if (val === 'Saturday') return model.sat.cutoff;
      return model.wed.cutoff
    }

    function renderCountdown(model) {
      const cutoff = selectedCutoff(model);
      const msLeft = cutoff - nowLocal();
      $hulllu.text(formatDuration(msLeft));
      $bullu.text('');

       function formatDayLabel(dateStr) {
        const date = new Date(dateStr);
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'long' });
        return `${day} ${month}`;
      }

      document.querySelector('.delivery-wed-date').textContent = formatDayLabel(model.wed.date);
    }

    let cachedKey = '';
    function tick() {
      const model = computeModel();
      const key = `${model.wed.date.toDateString()}|${model.sat.date.toDateString()}`;
      if (key !== cachedKey) {
        cachedKey = key;
        renderDates(model);
      }
      renderCountdown(model);
    }

    $inputs.on('change', function () {
      const val = $(this).val();
      tick();
      // $('.juo-layout').addClass('juo-layout-enable');
      // $('.juo-layout').css('opacity', 1);
      // $('.juo-layout').css('pointer-events', 'initial');
      // $([document.documentElement, document.body]).animate({
      //       scrollTop: $(".juo-layout").offset().top - 70
      //   }, 500);
    });

    $(function () {
      tick();
      setInterval(tick, 1000);
      setInterval(tick, 60000);
    });

     
    (function($) {
      var $section     = $('.meal-discount-selection-wrapper');
      var $mealOptions = $section.find('.meal-options');
      if (!$mealOptions.length) return;

      function currentMode() {
        // Change this selector if your toggle radios are different
         var phandle = $('#juo-products-section').attr('data-handle');
        if (!phandle) return 'subscription';
        if (phandle === 'tessas-mealbox') return 'onetime';
        return 'subscription';
      }

      function updateCards() {
        var mode = currentMode();

        $mealOptions.find('.meal-card').each(function() {
          var $card = $(this);

          var total, per, discount;
          if (mode === 'subscription') {
            total    = $card.data('sub-total');
            per      = $card.data('sub-per');
            discount = $card.data('sub-discount');
          } else {
            total    = $card.data('ot-total');
            per      = $card.data('ot-per');
            discount = $card.data('ot-discount');
          }

          if (total) { $card.find('.js-price-total').text(total); }
          if (per)   { $card.find('.js-price-per').text(per); }

          var $badge = $card.find('.js-discount-badge');
          if ($card.hasClass('is-selected') && discount) {
            $badge.text(discount).show();
          } else {
            $badge.hide();
          }
        });
      }

      function selectCard($card) {
        $mealOptions.find('.meal-card').removeClass('is-selected')
          .find('input[type="radio"]').prop('checked', false);

        $card.addClass('is-selected')
          .find('input[type="radio"]').prop('checked', true);

        updateCards();
      }

      // Clicking a card
      $mealOptions.on('click', '.meal-card', function(e) {
        e.preventDefault();
        selectCard($(this));
        var meals = parseInt($(this).data('meals'), 10) || 0;
        if (meals > 0) {
          $('.current-meal-count').text(meals);
        }
        // $('.deliver-date-boxx').css('opacity', 1);
        //   $('.deliver-date-boxx').css('pointer-events', 'initial');
        //   $([document.documentElement, document.body]).animate({
        //       scrollTop: $(".deliver-date-boxx").offset().top - 70
        //   }, 500);

           $inputs.trigger('change'); 

          $('.juo-layout').addClass('juo-layout-enable');
            $('.juo-layout').css('opacity', 1);
            $('.juo-layout').css('pointer-events', 'initial');
            $([document.documentElement, document.body]).animate({
                  scrollTop: $(".juo-layout").offset().top - 70
              }, 500);
          });
 
      updateCards();
    })(jQuery);


  });
 
  

$(document).ready(function () {

  var pid = $('#juo-products-section').attr('data-pid');
  var phandle = $('#juo-products-section').attr('data-handle');
  const pending = new Map();

  const SELECTORS = {
    card: '.juo-card',
    addBtn: '.add-to-cart',
    qtyWrap: '.product-qty',
    totalEl: '.cartTotal',
    shippingEl: '.at-che',
    discountEl: '.at-cheee',
    grandEl: '.cartTotalll',
    grandElMobile: '.cartTotalMob',
    mealCount: '.cont-crt',
    mealOffer: '.offrs',
    mealText: '.txxxt',
    mealBar: '.progrss-bar',
    freeShipHeadline: '#headline',
    freeShipFill: '#progressFill',
    dayRadio: '.delivery-day-selector',
    cartGoBtn: '.checkout-btn',
  };

  const formatMoney = (cents) => '€' + (cents / 100).toFixed(2);

  function getSelectedDay() {
    return $(SELECTORS.dayRadio + ':checked').val() || 'Wednesday';
  }
  function getDeliveryCode(day) {
    return day === 'Wednesday' ? 'LMV' : 'LMVD';
  }

  // Parse "34% off" or "34%" -> 34
  function parseDiscount(str) {
    if (!str) return 0;
    var m = String(str).match(/([\d.,]+)/);
    if (!m) return 0;
    return parseFloat(m[1].replace(',', '.')) || 0;
  }

  function isOneTimeMode() { 
    if (phandle === 'tessas-mealbox') return true;
 
    var v = $('[name="purchase_type"]:checked').val();
    return v === 'one_time' || v === 'onetime';
  }

  function updateAutoselectVisibility(totalQty) {
    var targetMeals = getSelectedMinMeals() ;
    
    if (totalQty >= targetMeals) {
      $('.autoselect-wrapper').attr('hidden',true);
      $('.autoselect-hr').attr('hidden',true);
    } else {
      var rm = targetMeals - totalQty;
      $('.current-meal-count').html(rm)
      $('.autoselect-wrapper').removeAttr('hidden');
      $('.autoselect-hr').removeAttr('hidden');
    }
    if($('#customCartDrawer').hasClass('mobile-cart-active') == false){
      $('.autoselect-wrapper.mobile').attr('hidden',true);
    }
  }


  // ---- build discount tiers from meal cards ----
  const MEAL_TIERS = (function buildTiers() {
    const tiers = [];

    $('.meal-card').each(function () {
      const $c = $(this);
      const meals = parseInt($c.data('meals'), 10) || 0;
      if (!meals) return;

      const subText = $c.data('sub-discount') || '';
      const otText  = $c.data('ot-discount')  || '';

      tiers.push({
        meals,
        subPercent: parseDiscount(subText),
        otPercent:  parseDiscount(otText),
        subText,
        otText,
        $card: $c,
      });
    });

    tiers.sort((a, b) => a.meals - b.meals);
    return tiers;
  })();

  function getTierDiscountPercent(tier) {
    if (!tier) return 0;
    return isOneTimeMode() ? (tier.otPercent  || 0) : (tier.subPercent || 0);
  }

  function getTierDiscountText(tier) {
    if (!tier) return '';
    return isOneTimeMode()
      ? (tier.otText  || (tier.otPercent  ? tier.otPercent  + '% korting' : ''))
      : (tier.subText || (tier.subPercent ? tier.subPercent + '% korting' : ''));
  }


  function getTierState(totalQty) {
    let current = null;
    let next = null;

    for (let i = 0; i < MEAL_TIERS.length; i++) {
      const tier = MEAL_TIERS[i];
      if (totalQty >= tier.meals) {
        current = tier;
      } else {
        next = tier;
        break;
      }
    }
    return { current, next };
  }

  function syncCardSelection(currentTier) {
    // if($('.deliver-date-boxx').find('.delivery-day-selector:checked').length == 0){
    //   return;
    // }
    // $('.meal-card').removeClass('is-selected');
 
    // const firstTier = MEAL_TIERS[0];
 
    // if (!currentTier) {
    //   if (firstTier && firstTier.$card) {
    //     firstTier.$card.addClass('is-selected');
    //   }
    //   return;
    // } 
    // if (currentTier.$card) {
    //   currentTier.$card.addClass('is-selected');
    // }
    // var $sel = $('.meal-card.is-selected').first();
    // if ($sel.length) return;

    // if (MEAL_TIERS.length && MEAL_TIERS[0].$card) {
    //   MEAL_TIERS[0].$card.addClass('is-selected');
    // } else {
    //   $('.meal-card').first().addClass('is-selected');
    // }
  }

  function getSelectedMinMeals() {
    var $sel = $('.meal-card.is-selected').first();

    if ($sel.length) {
      return parseInt($sel.data('meals'), 10) || 0;
    }

    // Fallback: if nothing is selected, use the first tier/card
    // if (MEAL_TIERS.length && MEAL_TIERS[0].$card) {
    //   MEAL_TIERS[0].$card.addClass('is-selected');
    //   return MEAL_TIERS[0].meals || 0;
    // }

    // var $first = $('.meal-card').first();
    // if ($first.length) {
    //   $first.addClass('is-selected');
    //   return parseInt($first.data('meals'), 10) || 0;
    // }

    return 0;
  }


  // --------- UI rendering helpers ----------

  function renderCards() {
    $(SELECTORS.card).each(function () {
      const $card = $(this);
      const variantId = String($card.data('variant-id'));
      const item = pending.get(variantId);

      const $existingBtn = $card.find('.add-to-cart').first();
      const $existingWrap =
        $existingBtn.length ? $existingBtn.closest('.button-wrapper').addBack().first() : null;

      $card.find(SELECTORS.qtyWrap).remove();

      if (item && item.qty > 0) {
        if ($existingWrap) $existingWrap.hide();
        $card.append(
          '<div class="product-qty" data-variant-id="' + variantId + '">' +
            '<button class="qty-btn minus" data-variant-id="' + variantId + '">-</button>' +
            '<span class="qty-count">' + item.qty + '</span>' +
            '<button class="qty-btn plus" data-variant-id="' + variantId + '">+</button>' +
            '<button class="qty-btn remove" style="display:none;" data-variant-id="' + variantId + '">x</button>' +
          '</div>'
        );
      } else {
        if ($existingWrap) $existingWrap.show();
      }
    });
  }

  function renderMiniCartFromPending() {
    const $cart = $('#cartItems').empty();
    let totalCents = 0;

    const entries = Array.from(pending.values()).filter((p) => p.qty > 0);
    if (!entries.length) {
      $cart.html('<p class="cart-toolf-empty">Your cart is empty.</p>');
      $('.cartTotal').text('€0.00');
      renderCards();
      return;
    }

    entries.forEach((p) => {
      const $card = $('.juo-card[data-variant-id="' + p.variantId + '"]');
      var price = Number($card.attr('data-price'));
      totalCents += price * p.qty;
      const title = $card.find('.for-juo-tiitle').html();
      const img = $card.find('img').first().attr('src') || '';

      $cart.append(
        '<div class="cart-item" data-variant-id="' + p.variantId + '">' +
          (img ? '<img src="' + img + '" >' : '') +
          '<div class="cart-item-info">' +
            '<p>' + title + '</p>' +
            '<p class="qui-car-pp">' + formatMoney(price) + '</p>' +
            '<div class="cart-quenntity">' +
              '<button class="qty-btn minus" data-variant-id="' + p.variantId + '">-</button>' +
              '<span>' + p.qty + '</span>' +
              '<button class="qty-btn plus" data-variant-id="' + p.variantId + '">+</button>' +
              '<button class="qty-btn remove" data-variant-id="' + p.variantId + '">x</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    });

    $('.cartTotal').text(formatMoney(totalCents));
  }

  // --------- core totals (discount + shipping) ----------

  function computeTotals() {
    let subtotalCents = 0;
    let totalQty = 0;

    pending.forEach((p) => {
      subtotalCents += (p.priceCents || 0) * (p.qty || 0);
      totalQty += p.qty || 0;
    });

    const { current, next } = getTierState(totalQty);
    const discountPercent = getTierDiscountPercent(current);
    const discountCents = Math.round(subtotalCents * (discountPercent / 100));

    // ── SHIPPING based on MEAL COUNT thresholds 4–7, 8–13, 14+ ──
    let shippingCents = 0;
    if (totalQty < 8) {
      shippingCents = 995;      // €9,95
    } else if (totalQty < 14) {
      shippingCents = 995;       // €9,95
    } else {
      shippingCents = 995;         // €9,95
    }

    const grandCents = Math.max(subtotalCents + shippingCents - discountCents, 0);

    return {
      subtotalCents,
      discountCents,
      shippingCents,
      grandCents,
      totalQty,
      discountPercent,
      currentTier: current,
      nextTier: next,
    };
  }


  function renderTotals() {
    const data = computeTotals();
    const {
      subtotalCents,
      discountCents,
      shippingCents,
      grandCents,
      totalQty,
    } = data;

    // highlight the correct meal card based on totalQty
    syncCardSelection();
    console.log(data.currentTier);

    $(SELECTORS.totalEl).text(formatMoney(subtotalCents));
    $(SELECTORS.discountEl).text('-' + formatMoney(discountCents));

    if (shippingCents === 0) {
      $(SELECTORS.shippingEl).text('Gratis').css('color', '#BF3');
    } else {
      $(SELECTORS.shippingEl).text(formatMoney(shippingCents)).css('color', '#ffffff');
    }

    $(SELECTORS.grandEl).text(formatMoney(grandCents));
    $(SELECTORS.grandElMobile).text(formatMoney(grandCents));

    renderMealBanner(data);
    renderFreeShipBar(data);
    toggleCheckoutEnable(data);
    updateAutoselectVisibility(totalQty);
  }

  // ---- Meal banner progress: based on current & next tier ----

  function renderMealBanner(data) {
    const { totalQty, discountPercent, currentTier, nextTier } = data;

    const $count = $(SELECTORS.mealCount);
    const $offrs = $(SELECTORS.mealOffer);
    const $text  = $(SELECTORS.mealText);
    const $bar   = $(SELECTORS.mealBar);

    const firstTier = MEAL_TIERS[0];

    // ⬇️ NEW: figure out which tier matches the currently selected card
    const selectedMinMeals = getSelectedMinMeals(); // e.g. 6, 8, 10...
    let selectedTier = null;
    if (selectedMinMeals) {
      selectedTier = MEAL_TIERS.find(t => t.meals === selectedMinMeals) || null;
    }
    if (!selectedTier) selectedTier = firstTier || null;

    let displayCount = '';
    let displayOffrs = '';
    let displayText  = '';
    let progress     = 0;

    if (!firstTier || !selectedTier) {
      // fallback when no tiers configured
      displayCount = totalQty + ' / 0';
      displayText  = '';
      progress     = 0;
    } else if (!currentTier) {
      // 🔸 BELOW first discount tier: use the SELECTED CARD as the minimum target
      const target  = selectedTier.meals;                 // <-- was firstTier.meals
      const remain  = Math.max(target - totalQty, 0);
      const discTxt = getTierDiscountText(selectedTier);  // <-- was firstTier

      displayCount = totalQty + ' / ' + target;
      displayOffrs = '';
      displayText  = remain > 0
        ? 'Voeg ' + remain + ' maaltijd' + (remain === 1 ? '' : 'en') +
          ' toe voor ' + discTxt + '.'
        : '';

      progress = target > 0 ? Math.min((totalQty / target) * 100, 100) : 0;
    } else if (currentTier && nextTier) {
      // BETWEEN current tier and next tier – unchanged
      var target  = selectedTier.meals;
      if(nextTier.meals > selectedTier.meals){
        target = nextTier.meals;
      }
      console.log(nextTier.meals + ' nextTier.meals')
      console.log(selectedTier.meals + ' selectedTier.meals')
      const remain  = Math.max(target - totalQty, 0);
      const currTxt = getTierDiscountText(currentTier);
      var nextTxt = getTierDiscountText(selectedTier);
      if(nextTier.meals > selectedTier.meals){
        nextTxt = getTierDiscountText(nextTier);
      }

      displayCount = totalQty + ' / ' + target;
      displayOffrs = 'Je hebt ' + currTxt + ' op je bestelling.';
      displayText  = 'Voeg ' + remain + ' maaltijd' +
                    (remain === 1 ? '' : 'en') +
                    ' toe voor ' + nextTxt + '.';

      progress = target > 0 ? Math.min((totalQty / target) * 100, 100) : 0;
    } else {
      // AT or ABOVE last tier – unchanged
      const target  = currentTier.meals;
      const currTxt = getTierDiscountText(currentTier);

      displayCount = totalQty + ' / ' + target + '+';
      displayOffrs = 'Profiteer van ' + currTxt + '.';
      displayText  = 'Profiteer van ' + currTxt + ' op deze bestelling.';
      progress     = 100;
    }

    // Discount pill only when there is a real discount
    if (discountPercent > 0) {
      $('.discoounted-codeed').show();
      $('.ten-per-text').text(discountPercent.toFixed(0) + '%');
    } else {
      $('.discoounted-codeed').hide();
    }

    $count.text(displayCount);
    $offrs.text(displayOffrs);
    $text.text(displayText);
    $bar.css({ width: progress + '%', backgroundColor: '#BBFF33' });
  }



  // ---- Shipping bar (updated) ----

function renderFreeShipBar(data) {
  const { totalQty } = data;
  const $headline = $(SELECTORS.freeShipHeadline);
  const $fill     = $(SELECTORS.freeShipFill);

  let pct  = 0;
  let text = '';

  if (totalQty < 15) {
    // 1–14 meals → €9,95 shipping
    const remaining = 15 - totalQty;

    // progress towards 15 meals
    pct = Math.min((totalQty / 15) * 100, 100);

    text = 'Wij hanteren altijd dezelfde bezorgkosten.';
  } else {
    // 15+ meals → €9,95 shipping
    pct = 100;
    text = 'Wij hanteren altijd dezelfde bezorgkosten (€9,95).';
  }

  $headline.text(text);
  $fill.css('width', pct + '%');
}



  // ---- Checkout enabled when at least first tier reached ----

  function toggleCheckoutEnable(data) {
    const { totalQty } = data;
    const $btn = $(SELECTORS.cartGoBtn);

    const required = getSelectedMinMeals(); // 👈 from selected card

    if (required > 0 && totalQty >= required) {
      $btn.removeClass('disabled').attr('aria-disabled', 'false');
    } else {
      $btn.addClass('disabled').attr('aria-disabled', 'true');
    }
  }

  // --------- events: add, change qty, etc. ----------

  $('.autoselect-btn').on('click', function () {
     
    var targetMeals = getSelectedMinMeals();

    if (!targetMeals) return;
 
    var totals  = computeTotals();
    var current = totals.totalQty || 0;
 
    var toAdd = targetMeals - current;
    if (toAdd <= 0) { 
      return;
    }

    var $allCards = $('.juo-card');
    if (!$allCards.length) return;
 
    function filterAvailable($set) {
      return $set.filter(function () {
        var variantId = String($(this).data('variant-id'));
        var item = pending.get(variantId);
        return !item || !item.qty; 
      }).toArray();
    }
 
    function shuffle(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    }
 
    var chefCards  = filterAvailable($allCards.filter('[data-ischef="true"]'));
    var otherCards = filterAvailable($allCards.not('[data-ischef="true"]'));

    shuffle(chefCards);
    shuffle(otherCards);

    function addFromList(list) {
      for (let idx = 0; idx < list.length && toAdd > 0; idx++) {
        var $card      = $(list[idx]);
        var variantId  = String($card.data('variant-id'));
        var priceCents = parseInt($card.data('price'), 10) || 0;
        var handle     = String($card.data('product-handle'));
        var wantsSub   = !!$card.data('selling-plan-group');

        var cur = pending.get(variantId) || {
          variantId,
          qty: 0,
          priceCents,
          handle,
          wantsSub,
        };

        if (cur.qty === 0) { 
          cur.qty = 1;
          pending.set(variantId, cur);
          toAdd--;
        }
      }
    }
 
    addFromList(chefCards);
 
    if (toAdd > 0) {
      addFromList(otherCards);
    }
 
    //$('.autoselect-wrapper').hide();
 
    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  });





  $(document).on('click', SELECTORS.addBtn, function (e) {
    e.preventDefault();
    const $card = $(this).closest(SELECTORS.card);
    const variantId = String($card.data('variant-id'));
    const handle = String($card.data('product-handle'));
    const priceCents = parseInt($card.data('price'), 10) || 0;
    const wantsSub = !!$card.data('selling-plan-group');

    const cur =
      pending.get(variantId) || { variantId, qty: 0, priceCents, handle, wantsSub };

    cur.qty += 1;
    pending.set(variantId, cur);

    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  });

  $(document).on('click', '.qty-btn', function () {
    const variantId = String($(this).data('variant-id'));
    const cur = pending.get(variantId);
    if (!cur) return;

    if ($(this).hasClass('plus')) cur.qty += 1;
    else if ($(this).hasClass('minus')) cur.qty = Math.max(cur.qty - 1, 0);
    else if ($(this).hasClass('remove')) cur.qty = 0;

    if (cur.qty === 0) pending.delete(variantId);
    else pending.set(variantId, cur);

    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  });

  $(document).on('change', SELECTORS.dayRadio, function () {
    renderTotals();
    renderMiniCartFromPending();
  });

  // if purchase type switches (sub / one-time), discount tiers might change
  $(document).on('change', '[name="purchase_type"]', function () {
    // in this script tiers are read once on load; if your toggle changes page,
    // you can refresh instead; for now we just recompute totals
    renderTotals();
    renderMiniCartFromPending();
  });

  // --------- checkout + delivery attrs ----------

  const $btn = $('.checkout-btn');
  const originalText = $btn.html();

  function updateAttrDay(code, day) {
    const dayn = getSelectedDay();
    const coden = getDeliveryCode(day);
    var formData = new FormData();
    formData.append('attributes[DeliveryCode]', coden);
    formData.append('attributes[DeliveryDay]', dayn);

    fetch('/cart/update.js', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then(() => {
        $btn.removeClass('loading').html(originalText);
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
        $btn.removeClass('loading').html(originalText);
      });
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });
  }

  $(SELECTORS.cartGoBtn)
    .unbind()
    .click(function (e) {
      if ($(this).hasClass('disabled')) {
        e.preventDefault();
        return;
      }
      e.preventDefault();

      const day = 'Wednesday';
      const code = getDeliveryCode(day);
      const entries = Array.from(pending.values()).filter((p) => p.qty > 0);
    
      $btn.addClass('loading').text('');

      if (entries.length === 0) {
        window.location.href = '/cart';
        return;
      }

      const itemsPayload = entries.map((p) => {
        const $card = $('.juo-card[data-variant-id="' + p.variantId + '"]');
        let sellingPlan = null;

        if (phandle == 'tessas-mealplan') {
          $card.find('.sell-item').each(function () {
            const planName = (($(this).data('planname') || '') + '').toLowerCase();
            const planId = $(this).data('plan');

            if (
              (day === 'Wednesday' && planName.includes('wednesday')) ||
              (day === 'Saturday' && planName.includes('saturday'))
            ) {
              sellingPlan = planId;
              return false;
            }
          });
        }

        const item = {
          id: Number(p.variantId),
          quantity: p.qty,
          properties: {
            _box: 'box-' + pid,
            _parent_product_handle: phandle,
            _parent_product_id: pid,
          },
        };

        if (sellingPlan) item.selling_plan = sellingPlan;
        return item;
      });  

      clearCart()
        .then(() =>
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsPayload }),
          })
        )
        .then((res) => {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(() => updateAttrDay(code, day))
        .catch((err) => {
          console.error(err);
          alert('Kon items niet toevoegen. Probeer het opnieuw.');
          $btn.removeClass('loading').text(originalText);
        })
        .finally(() => $(this).removeClass('disabled').attr('aria-disabled', 'false'));
    });

  // --------- init + mobile drawer ----------

  (function initCart() {
    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  })();

  $('.order-summer-mobile').on('click', function () {
    $('.juo-cart').addClass('mobile-cart-active');
    renderCards();
    renderTotals();
    renderMiniCartFromPending();
  });

  $('.mobile-close-srawerr, .juo-overlay').on('click', function () {
    $('.juo-cart').removeClass('mobile-cart-active');
    $('.mobile.autoselect-wrapper').attr('hidden',true)
     
  });
});
    
$(document).ready(function(){
  const params = new URLSearchParams(window.location.search);
  const gpid = params.get('pid'); 
  if(params.has('pid')){
    $('.juo-card[data-variant-id="' + gpid + '"]').find('.add-to-cart').trigger('click');
  }else{
    
  }
  
});
window.addEventListener('pageshow', function () {
  document.querySelectorAll('input[type="radio"]').forEach(radio => {
    radio.checked = false;
  });
});

(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  } 
})();    